<template>
  <div class="w-100 h-100 m-0 position-relative d-flex flex-column align-items-center" style="padding: 32px">
    <div class="row m-0 p-0 acry-page-title justify-content-center">アンケート</div>
    <div class="mb-0" style="margin-top:63px; font-size: 16px; width:552px;">
      <p class="m-0">アンケートにお答えください</p>
    </div>

    <div class="d-flex flex-column text-start" style="width:870px; margin-top:63px; ">
      <div class="cell d-flex flex-column">
        <div class="fw-bold" style="font-size: 16px;">
          Q1：ACRY PROをどこで知りましたか？（複数選択可）
        </div>
        <div class="d-flex flex-column" style="gap:16px;">
          <div class="d-flex flex-grow-1" style="gap: 40px;">
            <div class="d-flex mark-text-gap">
              <input class="input-radio" type="checkbox" id="q1_1" value="広告" v-model="q1_1" />
              <div class="a_text">広告</div>
            </div>
            <div class="d-flex mark-text-gap">
              <input class="input-radio" type="checkbox" id="q1_2" value="ACRYアプリ" v-model="q1_2" />
              <div class="a_text">ACRYアプリ</div>
            </div>
            <div class="d-flex mark-text-gap">
              <input class="input-radio" type="checkbox" id="q1_3" value="SNS" v-model="q1_3" />
              <div class="a_text">SNS</div>
            </div>
            <div class="d-flex mark-text-gap">
              <input class="input-radio" type="checkbox" id="q1_4" value="知人からの紹介" v-model="q1_4" />
              <div class="a_text">知人からの紹介</div>
            </div>
            <div class="d-flex mark-text-gap">
              <input class="input-radio" type="checkbox" id="q1_5" value="展示会やイベント" v-model="q1_5" />
              <div class="a_text">展示会やイベント</div>
            </div>
          </div>
          <div class="d-flex flex-grow-1" style="gap: 40px;">
            <div class="d-flex" style="gap: 16px; margin-top:10px;">
              <!-- <input class="input-radio" type="checkbox" id="q1_6" value="その他" v-model="q1_6" /> -->
              <div class="a_text">その他（自由記述）</div>
            </div>
            <div class="d-flex" style="gap: 14px; width:400px; height:40px;">
              <input type="text" v-model="q1_etc" class="forminput acry-text-main" placeholder=""  />
            </div>
          </div>
        </div>
      </div>

      <div class="cell d-flex flex-column">
        <div class="fw-bold" style="font-size: 16px;">
          Q2：今回ACRY PROを利用した目的を教えて下さい。（複数選択可）
        </div>
        <div class="d-flex flex-column" style="gap:16px;">
          <div class="d-flex flex-grow-1" style="gap: 40px;">
            <div class="d-flex mark-text-gap">
              <input class="input-radio" type="checkbox" id="q1_1" value="商品として販売（物販）" v-model="q2_1" />
              <div class="a_text">商品として販売（物販）</div>
            </div>
            <div class="d-flex mark-text-gap">
              <input class="input-radio" type="checkbox" id="q1_2" value="ノベルティとして" v-model="q2_2" />
              <div class="a_text">ノベルティとして</div>
            </div>
            <div class="d-flex mark-text-gap">
              <input class="input-radio" type="checkbox" id="q1_3" value="プレゼント、記念品製作として" v-model="q2_3" />
              <div class="a_text">プレゼント、記念品製作として</div>
            </div>
          </div>
          <div class="d-flex flex-grow-1" style="gap: 40px;">
            <div class="d-flex mark-text-gap">
              <input class="input-radio" type="checkbox" id="q1_4" value="自社サービスへの組込用途（販促物や特典として）" v-model="q2_4" />
              <div class="a_text">自社サービスへの組込用途（販促物や特典として）</div>
            </div>
            <div class="d-flex mark-text-gap">
              <input class="input-radio" type="checkbox" id="q1_5" value="試験的な利用、お試しとして" v-model="q2_5" />
              <div class="a_text">試験的な利用、お試しとして</div>
            </div>
          </div>
        </div>
      </div>

      <div class="cell d-flex flex-column">
        <div class="fw-bold" style="font-size: 16px;">
          Q3：サービス価格について近いものを回答ください。
        </div>
        <div class="d-flex flex-column" style="gap:16px;">
          <div class="d-flex flex-grow-1" style="gap: 40px;">
            <div class="d-flex mark-text-gap">
              <input class="input-radio" type="radio" id="q3" value="安いと感じた" v-model="q3" />
              <div class="a_text">安いと感じた</div>
            </div>
            <div class="d-flex mark-text-gap">
              <input class="input-radio" type="radio" id="q3" value="普通" v-model="q3" />
              <div class="a_text">普通</div>
            </div>
            <div class="d-flex mark-text-gap">
              <input class="input-radio" type="radio" id="q3" value="高いと感じた" v-model="q3" />
              <div class="a_text">高いと感じた</div>
            </div>
            <div class="d-flex mark-text-gap">
              <input class="input-radio" type="radio" id="q3" value="まだわからない" v-model="q3" />
              <div class="a_text">まだわからない</div>
            </div>
          </div>
          <div class="d-flex flex-grow-1" style="gap: 40px;">
            <div class="d-flex" style="gap: 16px; margin-top:10px;">
              <input class="input-radio" type="radio" id="q3" value="その他" v-model="q3" />
              <div class="a_text">その他（自由記述）</div>
            </div>
            <div class="d-flex" style="gap: 14px; width:400px; height:40px;">
              <input type="text" v-model="q3_etc" class="forminput acry-text-main" placeholder=""  />
            </div>
          </div>
        </div>
      </div>

      <div class="cell d-flex flex-column">
        <div class="fw-bold" style="font-size: 16px;">
          Q4：業種・業界を教えてください（自由記述）
        </div>
        <div class="d-flex flex-column" style="gap:16px;">
          <div class="d-flex flex-grow-1" style="gap: 40px;">
            <div class="d-flex" style="gap: 14px; width:600px; height:40px;">
              <input type="text" v-model="q4" class="forminput acry-text-main" placeholder=""  />
            </div>
          </div>
        </div>
      </div>

      <div class="cell d-flex flex-column">
        <div class="fw-bold" style="font-size: 16px;">
          Q5：他にアイテム製作したことがあるものを教えてください。（複数選択可）
        </div>
        <div class="d-flex flex-column" style="gap:16px;">
          <div class="d-flex flex-grow-1" style="gap: 40px;">
            <div class="d-flex mark-text-gap">
              <input class="input-radio" type="checkbox" id="q5_1" value="ステッカー" v-model="q5_1" />
              <div class="a_text">ステッカー</div>
            </div>
            <div class="d-flex mark-text-gap">
              <input class="input-radio" type="checkbox" id="q5_2" value="缶バッチ" v-model="q5_2" />
              <div class="a_text">缶バッチ</div>
            </div>
            <div class="d-flex mark-text-gap">
              <input class="input-radio" type="checkbox" id="q5_3" value="Tシャツ" v-model="q5_3" />
              <div class="a_text">Tシャツ</div>
            </div>
            <div class="d-flex mark-text-gap">
              <input class="input-radio" type="checkbox" id="q5_4" value="アクリル製品" v-model="q5_4" />
              <div class="a_text">アクリル製品</div>
            </div>
            <div class="d-flex mark-text-gap">
              <input class="input-radio" type="checkbox" id="q5_4" value="なし" v-model="q5_5" />
              <div class="a_text">なし</div>
            </div>
          </div>
          <div class="d-flex flex-grow-1" style="gap: 40px;">
            <div class="d-flex" style="gap: 16px; margin-top:10px;">
              <!-- <input class="input-radio" type="checkbox" id="q1_6" value="その他" v-model="q1_6" /> -->
              <div class="a_text">その他（自由記述）</div>
            </div>
            <div class="d-flex" style="gap: 14px; width:400px; height:40px;">
              <input type="text" v-model="q5_etc" class="forminput acry-text-main" placeholder=""  />
            </div>
          </div>
        </div>
      </div>

      <div class="cell d-flex flex-column">
        <div class="fw-bold" style="font-size: 15px;">
          Q6：今後、ACRY PROで機能追加や改善してほしい点など、ご要望、ご質問などあればご自由にご記入ください。
        </div>
        <div class="d-flex flex-column" style="gap:16px;">
          <div class="d-flex flex-grow-1" style="gap: 40px;">
            <div class="d-flex" style="gap: 14px; width:600px; height:60px;">
              <textarea v-model="q6" class="forminput acry-text-main" placeholder=""  />
            </div>
          </div>
        </div>
      </div>

      <div class="cell d-flex flex-column">
        <div class="fw-bold" style="font-size: 16px;">
          今回の無料お試しのご利用は「商業目的」としております。以下内容をご確認ください。
        </div>
        <div class="d-flex flex-column" style="gap:0px;">
          <div class="d-flex flex-grow-1" style="gap: 40px;">
            <div class="d-flex mark-text-gap">
              <input class="input-radio" type="checkbox" id="q7" value="今回の無料お試しにおいて個人目的での利用は行いません。" v-model="q7" />
              <div class="a_text">今回の無料お試しにおいて個人目的での利用は行いません。</div>
            </div>
          </div>
          <div class="d-flex flex-grow-1" style="gap: 40px; margin-top: 10px;">
            <div class="d-flex mark-text-gap">
              <input class="input-radio" type="checkbox" id="q8" value="業務用、商業目的での利用について理解しています。" v-model="q8" />
              <div class="a_text">業務用、商業目的での利用について理解しています。</div>
            </div>
          </div>
        </div>
      </div>

    </div>


    <button class="mx-0 acry-btn fw-bold" style="width: 240px; height: 56px; border-radius: 100px; font-size: 16px; margin-top:40px;" @click="clickSendBtn">
      送信
    </button>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import { CenterViewState, PaymentType } from "@/js/Const.js";
import { User } from "@/js/User.js";
import { Logger } from '@/js/utils/Logger.js';
import axios from 'axios'
import config from 'config'


export default {
  name: "CenterViewFirstTimeFreeSurvey_Ap",
  props: {},
  data: function () {
    return {
      q1_1:false,
      q1_2:false,
      q1_3:false,
      q1_4:false,
      q1_5:false,
      q1_etc:"",
      q2_1:false,
      q2_2:false,
      q2_3:false,
      q2_4:false,
      q2_5:false,
      q3:"",
      q3_etc:"",
      q4:"",
      q5_1:false,
      q5_2:false,
      q5_3:false,
      q5_4:false,
      q5_5:false,
      q5_etc:"",
      q6:"",
      q7:false,
      q8:false,
    };
  },
  computed: {},
  created() {
  },
  components: {},
  methods: {
    async clickSendBtn(){

      // アンケートに回答しているかチェック
      if(!this.checkSurveyAnswer()) {
        return;
      }

      this.$store.commit("showLoading");

      const address = (config.isDebug)?
      "x-aaaaq4zz3z3ibmjofmzwvel6py@n-ship.slack.com":
      "x-aaaaq3hi3dlahfxzzk6tdlxabm@n-ship.slack.com";

      //アンケート送信
      await this.sendMail(
        {
          data:{
            from: "survey@acry.co.jp",
            display: "ACRY PRO",
            to: address,
            subject: "アンケート送信",
            html: await this.mailText(),
          }
        }
      );

      this.$store.commit("hideLoading");

      // 購入処理開始
      await this.orderProcess();

      // キャンペーンを使用済みに
      Logger.info("メール送信");
    },

    checkSurveyAnswer(){
      if( !(this.q1_1 || this.q1_2 || this.q1_3 || this.q1_4 || this.q1_5 || this.q1_6 || this.q1_etc != "") ){
        this.$store.commit("showMessage", "Q1の質問に回答してください");
        return false;
      }
      if( !(this.q2_1 || this.q2_2 || this.q2_3 || this.q2_4 || this.q2_5) ){
        this.$store.commit("showMessage", "Q2の質問に回答してください");
        return false;
      }
      if( !(this.q3) ){
        this.$store.commit("showMessage", "Q3の質問に回答してください");
        return false;
      }
      if( !(this.q4) ){
        this.$store.commit("showMessage", "Q4の質問に回答してください");
        return false;
      }
      if( !(this.q5_1 || this.q5_2 || this.q5_3 || this.q5_4 || this.q5_5 || this.q5_etc != "") ){
        this.$store.commit("showMessage", "Q5の質問に回答してください");
        return false;
      }

      if( !(this.q7) ){
        this.$store.commit("showMessage", "規約に同意してください");
        return false;
      }

      if( !(this.q8) ){
        this.$store.commit("showMessage", "規約に同意してください");
        return false;
      }

      return true;
    },


    async orderProcess() {
      this.$store.commit("showProgress", true);
      this.$store.commit("setProgress", 0);
      this.$store.commit("setSendBytes", 0);

      this.$store.commit("setProgressMessages", [
        "デザイン送信中…",
        "しばらくお待ちください",
      ]);

      let productData = []; // API送信時に使用
      let marginTotal = 0;
      let marginTotalIncTax = 0;

      let progressPlus = (95 / this.$store.state.products.length).toFixed();
      let prog = 0;
      //let totalSendBytes = 0;

      let acrylProducts = []; // firebaseへの登録で使用
      let quantityTotal = 0; // 注文時間の推測に使用


      // プロダクト分ループ
      {
        let p = this.$store.state.currentProduct;
        acrylProducts.push(p);
        let firstProg = prog;

        // 事前に生成していない場合のみ
        // データをアップロード
        // この関数でZIPデータ保存、デザイン画像保存が一気にできる
        await this.$store.state.currentProduct.uploadDesignData(()=>{});

        for (let i = 0; i < p.quantity; ++i) {
          console.log("getProductData" + i);

          prog = firstProg + progressPlus * 0.8;
          //this.$store.commit("setProgress", prog.toFixed());
          let pdata = await p.getProductItemData(i);
          prog += progressPlus * 0.2;
          //this.$store.commit("setProgress", prog.toFixed());

          marginTotal += Number(pdata.margin);
          marginTotalIncTax += Number(pdata.margin_inctax);
          //priceTotal += Number(pdata.price_inctax);
          //priceTotal += Number(pdata.price_inctax);
          //taxTotal += pdata.tax;

          productData.push(pdata);
        }

        quantityTotal += parseInt(p.quantity);
      }

      // quantityTotal += parseInt(this.$store.state.cartManager.cartList.length);

      this.$store.commit("setProgress", 3);
      let priceData = this.createProductPriceData();
      console.log(priceData);

      let delivTax = Math.ceil(priceData.delivPrice * this.$common.getTax());

      let data = {
        deliv_check: this.$store.state.firstTimeFree.selectedDestination.other_deliv_id,
        fee_base: "0",
        fee_tax_rate: "0",
        fee_tax: "0",
        fee: "0",
        // 送料(税抜き)
        deliv_fee_base: priceData.delivPrice,
        // 送料税率
        deliv_fee_tax_rate: (this.$common.getTax() * 100).toFixed(),
        // 送料税額
        deliv_fee_tax: delivTax,
        // 送料税込
        deliv_fee: priceData.delivPrice + delivTax,
        // マージン率
        margin_rate: User.userData.introduced_margin,
        // マージン額合計(税抜き)
        margin_total: marginTotal,
        // マージン額合計(税込み)
        margin_total_inctax: marginTotalIncTax,
        // 商品代金税込マージン込み
        subtotal:
          priceData.productPrice +
          Math.ceil(priceData.productPrice * this.$common.getTax()),
        // 合計税額 送料分の税額は省く
        tax: priceData.taxPrice - delivTax,
        payment_total: priceData.totalPrice,
        discount: priceData.discount,
        message: "",
      };
      this.$common.log(data);

      this.$store.commit("setProgress", 3);

      const TotalTime = 0.34 * quantityTotal;
      let oneSecondProgress = (99 - 3) / TotalTime;
      let progress = 3.0;

      let timer = setInterval(
        function () {
          progress += oneSecondProgress;

          if (99 < parseInt(progress)) {
            this.$store.commit("setProgress", 99);
          } else {
            this.$store.commit("setProgress", parseInt(progress));
          }
        }.bind(this),
        1000
      );

      // 注文APIを実行
      const orderResult = await User.orderProduct(productData, data, PaymentType.ACRY_PRO_FREE)
        .then(
          (result) => {
            clearInterval(timer);
            return result;
        })
        .catch((error) => {
          clearInterval(timer);
          this.$handleError("064", error, { hideProgress: true });
        });
      if (!orderResult) return;

      await User.orderComplete(orderResult.order_id).catch((error) => {
          clearInterval(timer);
          this.$handleError("065", error, { hideProgress: true });
        });

      // 注文履歴に登録
      // firestore
      this.$store.state.orderHistoryManager
        .registOrderHistoryData(orderResult.order_id, {acrylProducts})
        .then(() => {
          // 注文完了
          this.$store.commit("setProgress", 100);
          //this.$store.commit("hideLoading");
          this.$store.commit("hideProgress");
          orderResult.payment_total = data.payment_total;
        })
        .catch((e) => {
          this.$handleError("066", e, { hideProgress: true });
        });

      // キャンペーンの情報を登録
      const doc = {
        uid:firebase.auth().currentUser.uid,
        orderId:orderResult.order_id,
        type:this.$store.state.campaignManager.CampaignIds.FirstTimeFree,
        data: await this.mailText(),
      }
      await this.$store.state.campaignManager.setFirstTimeFreeData(doc);

      this.$store.commit("setCenterViewState", CenterViewState.FirstTimeFreeSurveyComplete);
    },

    // カート内の商品価格の計算を行う
    createProductPriceData() {
      let productPriceData = {};
      productPriceData.productList = [];
      productPriceData.totalPrice = 0; // 払うべき金額 送料 + 商品合計 + 消費税合計 - 割引額
      productPriceData.delivPrice = 0; // 送料 (税別)
      productPriceData.productPrice = 0; // 商品合計 (税別)
      productPriceData.taxPrice = 0; // 消費税合計
      productPriceData.discount = 0; // アクリル商品の割引額 (税込)

      // let p = this.$store.state.currentProduct;

      let product = {};
      product.title = 0;
      product.price = 0;
      product.tax = 0;
      product.quantity = this.acrylNum;
      product.discount = 0;
      product.getProductTitle = function () {
        return "title";
      };
      productPriceData.productList.push(product);

      // productPriceData.productPrice += product.price * product.quantity;
      // productPriceData.taxPrice += product.tax * product.quantity;
      // productPriceData.discount += product.discount;
      // productPriceData.totalPrice += (product.price + product.tax) * product.quantity;

      // // 送料計算
      // productPriceData.delivPrice = 0;
      // productPriceData.taxPrice += productPriceData.delivPrice * Common.getTax();
      // productPriceData.totalPrice += productPriceData.delivPrice * (Common.getTax() + 1);

      // // 割引分を引く
      // productPriceData.totalPrice -= productPriceData.discount;

      // // 最終金額
      // productPriceData.taxPrice = Math.floor(productPriceData.taxPrice);
      // productPriceData.totalPrice = Math.floor(productPriceData.totalPrice);

      return productPriceData;
    },

    async mailText(){
      let q1t = "";
      if( this.q1_1 ){ q1t += "広告、"; }
      if( this.q1_2 ){ q1t += "ACRYアプリ、"; }
      if( this.q1_3 ){ q1t += "SNS、"; }
      if( this.q1_4 ){ q1t += "知人からの紹介、"; }
      if( this.q1_5 ){ q1t += "展示会やイベント、"; }
      if( this.q1_etc ){ q1t += this.q1_etc; }

      let q2t = "";
      if( this.q2_1 ){ q2t += "商品として販売（物販）、"; }
      if( this.q2_2 ){ q2t += "ノベルティとして、"; }
      if( this.q2_3 ){ q2t += "プレゼント、記念品製作として、"; }
      if( this.q2_4 ){ q2t += "自社サービスへの組込用途（販促物や特典として）、"; }
      if( this.q2_5 ){ q2t += "試験的な利用、お試しとして、"; }

      let q3t = this.q3;
      if( this.q3 == "その他" ){
        q3t += "、" + this.q3_etc;
      }
      let q4t = this.q4;

      let q5t = "";
      if( this.q5_1 ){ q5t += "ステッカー、"; }
      if( this.q5_2 ){ q5t += "缶バッチ、"; }
      if( this.q5_3 ){ q5t += "Tシャツ、"; }
      if( this.q5_4 ){ q5t += "アクリル製品、"; }
      if( this.q5_5 ){ q5t += "なし、"; }
      if( this.q5_etc ){ q5t += this.q5_etc; }

      let q6t = this.q6;

      const userInfo = await User.getInfo().catch(() => {
      });

      return `
      アンケート<br>
      <br>
      ${'uid:' + firebase.auth().currentUser.uid} <br>
      ${userInfo.company_name} <br>
      ${userInfo.name01 + ' ' + userInfo.name02} <br>
      <br>
      <br>
      Q1：ACRY PROをどこで知りましたか？（複数選択可）<br>
      ${q1t} <br>
      <br>
      Q2：今回ACRY PROを利用した目的を教えて下さい。（複数選択可）<br>
      ${q2t}<br>
      <br>
      Q3：サービス価格について近いものを回答ください。<br>
      ${q3t} <br>
      <br>
      Q4：業種・業界を教えてください（自由記述）<br>
      ${q4t} <br>
      <br>
      Q5：他にアイテム製作したことがあるものを教えてください。（複数選択可）<br>
      ${q5t} <br>
      <br>
      Q6：今後、ACRY PROで機能追加や改善してほしい点など、ご要望、ご質問などあればご自由にご記入ください。<br>
      ${q6t} <br>
      <br>
      `;
    },
    async sendMail(param){
      const url = (config.isDebug)?
      "https://asia-northeast1-shiptest-bbabd.cloudfunctions.net/SendMail":
      "https://asia-northeast1-shiptest-bbabd.cloudfunctions.net/SendMail";

      return axios.post(url, param)
          .then((response) => {
            Logger.debug(response);
          })
          .catch((e) => {
            Logger.error(e);
          });
    },

  },
};
</script>

<style scoped lang="scss">
.cell{
  padding:32px;
  border-bottom: solid 1px #E0E0E0;
  gap: 16px;
}

.mark-text-gap{
  gap: 14px;
}

.a_text{
  font-size: 15px;
}

.input-radio{
  width: 24px;
  height: 24px;
  accent-color: #8593bc;
}

.forminput {
  width: 100%;
  border: 1px solid #D1D5DB;
}


</style>
